import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	title: {
		id: 'invite-prompt.invite-success-flag.title',
		defaultMessage:
			'{inviteeCount, plural, one {Invite successfully sent} other {Invites successfully sent}}',
		description: 'Title of success flag shown when invites are sent successfully',
	},
	descriptionGenericOne: {
		id: 'invite-prompt.invite-success-flag.description-generic.one',
		defaultMessage:
			'We emailed <strong>{inviteeEmailOrName}</strong> inviting them to {productDisplayName}.',
		description: 'Description informing the user the invite was successfully sent',
	},
	descriptionGenericPlural: {
		id: 'invite-prompt.invite-success-flag.description-generic.plural',
		defaultMessage:
			'We emailed <strong>{inviteeCount} people</strong> inviting them to {productDisplayName}.',
		description: 'Description informing the user how many invites were successfully sent',
	},
	additionalInfoGeneric: {
		id: 'invite-prompt.invite-success-flag.additional-info-generic',
		defaultMessage:
			"Some people might need your admin's approval before they can join {productDisplayName}.",
		description: 'Description explaining that some invitees will still require admin approval',
	},
});
